import { vulnerabilitiesApi } from 'modules/cm/api';
import { CaseId } from 'modules/cm/api/cases/types';
import { Dispatch } from 'redux';
import {
  gettingVulnerabilitiesFinish,
  startGettingVulnerabilities,
  gettingVulnerabilitiesError,
} from '../store/actions';

const getVulnerabilities = (caseId: CaseId, applicantId: number, applicantIndex: number) => {
  return async (dispatch: Dispatch) => {
    dispatch(startGettingVulnerabilities(applicantIndex));
    try {
      const vulnerabilities = await vulnerabilitiesApi(caseId)(applicantId).getAll();

      dispatch(gettingVulnerabilitiesFinish(applicantIndex, vulnerabilities));
    } catch (error) {
      dispatch(gettingVulnerabilitiesError(applicantIndex, 'Could not fetch vulnerabilities.'));
    }
  };
};

export default getVulnerabilities;
